import { Study } from "./Study";

export interface Thumbnail {
  id: string;
  description: string;
  type: string;
  images: number;
  dicom: boolean;
  url: string;
  file: File;
  study: Study | undefined;
}

export const createThumbnail = (
  id: string,
  file: File,
  study: Study | undefined,
  description: string = "",
  type: string = "",
  images: number = 0,
  dicom: boolean = false,
  url: string = ""
) => ({
  id: id,
  file: file,
  study: study,
  description: description,
  type: type,
  images: images,
  dicom: dicom,
  url: url,
});
